// extracted by mini-css-extract-plugin
module.exports = {"container":"Details_container__1QUqr","flex_row":"Details_flex_row__1SbVk"};